import React from "react";
import SelectCountryDropdown from "./SelectCountry";
import RawPhoneNumberField from "./RawPhoneNumberField";
import { CountryChangeArgsType, PhoneNumberType, PhoneNumberWrapperType } from "./type";

/**
 * @name PhoneNumberWrapper
 * @description This component wrap country select & input field for phone numbers
 * @param onChangeHandler
 * @param props
 * @constructor
 */
export default function PhoneNumberWrapper({ onChangeHandler, ...props }: PhoneNumberWrapperType) {
  const [{ countryCode, phoneNumber, dialCode }, setPhoneFieldValues] = React.useState<PhoneNumberType>(
    props.initialPhoneValues
  );

  const numberFieldRef = React.useRef<HTMLInputElement>();

  const onRawPhoneNumberChange = React.useCallback(
    async number => {
      setPhoneFieldValues(oldVal => {
        const updatedValue = { ...oldVal, phoneNumber: number };
        if (number) {
          onChangeHandler(updatedValue);
        } else {
          onChangeHandler({ dialCode: "", countryCode: "", phoneNumber: "" });
        }
        return updatedValue;
      });
    },
    [onChangeHandler]
  );

  const onCountryCodeChange = React.useCallback(
    async (args: CountryChangeArgsType) => {
      setPhoneFieldValues(oldVal => {
        const updatedValue = { ...oldVal, countryCode: args.countryCode, dialCode: args.dialCode };
        updatedValue.phoneNumber && onChangeHandler(updatedValue);
        return updatedValue;
      });
      numberFieldRef.current?.focus();
    },
    [onChangeHandler]
  );

  return (
    <div className="mobileNumber_wrapper">
      <SelectCountryDropdown
        dialCode={dialCode}
        countryCode={countryCode}
        onBlur={props.onBlurHandler}
        onChange={onCountryCodeChange}
        name={props.name + "_countryCode"}
        disabled={props.disabled}
      />
      <RawPhoneNumberField
        disabled={props.disabled}
        innerRef={numberFieldRef}
        name={props.name}
        value={phoneNumber}
        hasError={props.hasError}
        onChange={onRawPhoneNumberChange}
        onBlur={props.onBlurHandler}
      />
    </div>
  );
}
